import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Refresh = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <g>
      <path d="M9 9.875l3.25.042a6.527 6.527 0 0 1-5.472 2.964A5.99 5.99 0 0 1 1.017 7h-1a6.7 6.7 0 0 0 6.762 6.881A7.941 7.941 0 0 0 13 10.667V14h1V9H9v.875zm-4-5.75l-3.242-.041a6.535 6.535 0 0 1 5.476-2.965A6 6 0 0 1 13 7h1A6.709 6.709 0 0 0 7.231.119 7.964 7.964 0 0 0 1 3.333V0H0v5h5v-.875z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Refresh;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Refresh.js